<!-- left -->
<div class="media">
    <mat-icon class="horse__photo-not-found" svgIcon="help" aria-hidden="false" aria-label="icone aucun resultat"></mat-icon>
</div>
<!-- right -->
<div class="main">
    <div class="main-info">
        <h4>désolé, nous n'avons pas trouvé d'annonce</h4>
        <div class="main-info__sub">
            <span>merci, vérifiez votre recherche</span>
        </div>
    </div>
</div>